import Feed from "./feed";
import {newsSourceSelector, NewsSourceSelector} from "./news-source-selector/NewsSourceSelectorComponent";
import {newsItemDialog, NewsItemDialog} from "./news-item-dialog/NewsItemDialogComponent";
import {newsIndicator, NewsIndicator} from "./news-indicator/CompanyNewsIndicatorComponent";
import {latestCompanyNews, LatestCompanyNews} from "./latest-news/LatestCompanyNewsComponent";

export default function(parentModule: string): string {
    const moduleName = `${parentModule}.components`;
    return angular.module(moduleName, [Feed(moduleName)])
                  .component(LatestCompanyNews, latestCompanyNews())
                  .component(NewsIndicator, newsIndicator())
                  .component(NewsSourceSelector, newsSourceSelector())
                  .component(NewsItemDialog, newsItemDialog())
                  .name;
}
